module.exports = __webpack_public_path__ + "img/orange_061.78e7aace.png";